import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useSignUpCardStyles } from './styles/signUpCardStyles';

interface SignUpCardProps {
  image: string;
  alt: string;
  title: string;
  description: string;
}

const SignUpCard: React.FC<SignUpCardProps> = ({ image, alt, title, description }) => {
  const theme = useTheme();
  const styles = useSignUpCardStyles(theme);

  return (
    <Card className={styles.card} data-testid="signup-card">
      <Typography variant="h5" className={styles.title} data-testid="signup-card-title">
        {title}
      </Typography>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingTop: '50%',
          overflow: 'hidden',
        }}
        data-testid="signup-card-image-container"
      >
        <Box
          component="img"
          src={image}
          alt={alt}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          data-testid="signup-card-image"
        />
      </Box>
      <CardContent data-testid="signup-card-content">
        <Typography
          variant="body2"
          className={styles.description}
          data-testid="signup-card-description"
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SignUpCard;
